// вынес в fias.views
export const getAllHousesIdsFromFiasTree = (
  fiasTreeLevel: {
    [propName: string]: any;
  }[]
): any[] => {
  return fiasTreeLevel
    .map((fiasLevel: { [propName: string]: any }) =>
      fiasLevel.houses
        ? fiasLevel.houses.map((houseObj: any) => houseObj._id)
        : getAllHousesIdsFromFiasTree(fiasLevel.inheritors)
    )
    .flat(Infinity);
};

export const findFiasTreeHouseById = (
  fiasTreeLevel: { [propName: string]: any }[],
  houseId: string,
  houseArray: { _id: string; short_address: string; parent?: string }[],
  withParentsAOGUID: boolean
) => {
  fiasTreeLevel.forEach((fiasLevel: { [propName: string]: any }) => {
    if (fiasLevel.inheritors?.length) {
      findFiasTreeHouseById(
        fiasLevel.inheritors,
        houseId,
        houseArray,
        withParentsAOGUID
      );
    }

    if (fiasLevel.houses) {
      const house = fiasLevel.houses.find(
        (houseObj: any) => houseObj._id === houseId
      );
      return house
        ? !!houseArray.push(
            withParentsAOGUID ? { ...house, parent: fiasLevel.AOGUID } : house
          )
        : false;
    }
  });
};
